import { useId } from 'react';
import paths from '@/components/logo-paths.json';

// Artwork is generated by brand/build_logo.py; edit the script, not these paths.

export function LogoMark({ className = 'h-8 w-8', title }) {
  const gradientId = `fishto-icon-${useId().replace(/:/g, '')}`;
  return (
    <svg
      viewBox={paths.icon.viewBox}
      className={className}
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      aria-label={title}
    >
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#2997FF" />
          <stop offset="1" stopColor="#0066CC" />
        </linearGradient>
      </defs>
      <path fill={`url(#${gradientId})`} d={paths.icon.squircle} />
      <path fill="#FFFFFF" fillRule="evenodd" transform={paths.icon.fishTransform} d={paths.icon.fish} />
    </svg>
  );
}

export default function Logo({ tone = 'dark', className = 'h-6 w-auto' }) {
  const gradientId = `fishto-word-${useId().replace(/:/g, '')}`;
  const light = tone === 'light';
  return (
    <svg
      viewBox={paths.wordmark.viewBox}
      className={`${light ? 'text-snow' : 'text-fg'} ${className}`}
      role="img"
      aria-label="Fishto"
    >
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#2997FF" />
          <stop offset="1" stopColor="#0066CC" />
        </linearGradient>
      </defs>
      <path fill="currentColor" d={paths.wordmark.letters} />
      <path fill={light ? '#2997FF' : `url(#${gradientId})`} fillRule="evenodd" d={paths.wordmark.fish} />
    </svg>
  );
}
